import classnames from 'classnames'
import styles from './styles.module.scss'

type ITypingIndicatorProps = {
  marginLeft?: number
  className?: string
}

export const TypingIndicator = ({ marginLeft, className }: ITypingIndicatorProps) => {
  return (
    <div className={classnames(styles.typing, className)} style={{ marginLeft }}>
      <div className={styles.typing__dot}></div>
      <div className={styles.typing__dot}></div>
      <div className={styles.typing__dot}></div>
    </div>
  )
}
